import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

import PostApi from "api/postApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import ModalPreview from "components/Common/ModalPreview";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import {
  COLOR_STATUS_POST,
  COLOR_WINK_TYPE_USER,
  STATUS_POST_OPTION,
  WINK_TYPE_USER_OPTION,
} from "helpers/constans";
import {
  formatDateStringToKorea,
  formatDateStringToUTC,
  formatNumberWithCommas,
} from "helpers/format";
import CountUp from "react-countup";
import { getWinks } from "store/post/thunk";
import CreateEditWink from "./CreateEditWink";
import CollapseContent from "components/Common/CollapseContent";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownAsyncBars from "components/Common/DropdownAsyncBars";
import BarListDetail from "pages/BarList/BarListDetail";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import ModalComment from "./ModalComment";
import DropdownAsyncUserWink from "components/Common/DropdownAsyncUserWink";
import CopyWrapper from "components/Common/CopyWrapper";

export interface Tag {
  id: string;
  text: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const MediaList = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const STATUS_FEED_OPTION_LANG =
    STATUS_POST_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    keyword: withDefault(StringParam, ""),
    type: withDefault(StringParam, "5"),
    status: withDefault(StringParam, ""),
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),
    bar_id: withDefault(StringParam, ""),
    user_id: withDefault(StringParam, ""),
    user_type: withDefault(StringParam, ""),

    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [itemToBarDetail, setItemToBarDetail] = useState<any>(null);
  const [itemToComment, setItemToComment] = useState<any>(null);
  const [typeScreen, setTypeScreen] = useState<string>('feed');

  const [keywordSearch, setKeywordSearch] = useState<string>(
    query["condition[title]"] || ""
  );

  const [statusSearch, setStatusSearch] = useState<any>(
    STATUS_POST_OPTION?.find(
      (item) => (item?.value) === (parseInt(query?.status))
    )?.value ?? ""
  );

  const [barSearch, setBarSearch] = useState<any | null>({
    label: t("All Filter"),
    value: "all",
  });

  const [bartenderSearch, setBartenderSearch] = useState<any | null>({
    label: t("All Filter"),
    value: "all",
  });

  const [userTypeSearch, setUserTypeSearch] = useState<any>(
    WINK_TYPE_USER_OPTION?.find(
      (item) => (item?.value) === (parseInt(query?.user_type))
    )?.value ?? ""
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [start_date, end_date] = dateSearch;

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Wink;

  const PostProperties = createSelector(selectLayoutState, (state) => ({
    posts: state.posts,
    isPostLoading: state.isPostLoading,
    isPostSuccess: state.isPostSuccess,

    error: state.error,
  }));

  // Inside your component
  const { posts, isPostLoading } = useSelector(PostProperties);

  function loadTableData() {
    dispatch(getWinks(query));
  }

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  const [linkImage, setLinkImage] = useState<any>(null);
  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const searchData = () => {
    setQuery({
      ...query,
      keyword: keywordSearch.trim() || "",
      status: statusSearch,
      user_type: userTypeSearch,
      bar_id: barSearch?.data?.id || "",
      user_id: bartenderSearch?.value !== 'all' ? bartenderSearch?.value : "",
      start_date: start_date
        ? formatDateStringToUTC(moment(new Date(start_date)).startOf("day").format("Y-MM-DD HH:mm:ss"))
        : "",
      end_date: end_date ? formatDateStringToUTC(moment(new Date(end_date)).endOf("day").format("Y-MM-DD HH:mm:ss")) : "",
      sort_by: "created_at",
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        status: "",
        user_type: "",
        bar_id: "",
        start_date: "",
        end_date: "",
        sort_by: "created_at",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setKeywordSearch((_prev) => "");
    setStatusSearch((_prev: any) => "");
    setUserTypeSearch((_prev: any) => "");
    setBarSearch({
      label: t("All Filter"),
      value: "all",
    });
    setDateSearch([null, null]);
    setBartenderSearch({
      label: t("All Filter"),
      value: "",
    });
  };

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // Begin::Change status
  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    is_active: string | boolean;
  }) => {
    try {
      if (!item) {
        return;
      }
      const response: any = await PostApi?.updatePost(item?.id, {
        "post": {
          is_active: item?.is_active,
          type: 5
        }
      });

      if (response?.data) {
        // setItemUpdate((_prev) => null);
        loadTableData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Change status

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        thClass: "align-middle whitespace-nowrap",
        Cell: ({ ...props }) => {
          const item = props?.row?.original;
          return (
            <CopyWrapper contentCopy={item?.id || ''} style={{ display: 'inline-flex', minWidth: '60px' }}>
              <div>
                {posts?.pagination?.total -
                  ((query?.page - 1) * query?.limit + props?.row?.index)}
              </div>
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Active"),
        accessor: "is_active",
        thWidth: 80,
        filterable: false,
        sortable: false,
        thClass: "align-middle text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="is_active"
                id="customSwitchsizelg"
                checked={item?.is_active === 1}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({
                    id: item?.id,
                    is_active: !!value ? "1" : "0",
                  });
                }}
              />
            </div>
          );
        },
      },

      {
        Header: t("Photo"),
        accessor: "files",
        thClass: "align-middle text-center",
        filterable: true,
        sortable: false,
        thWidth: 170,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const isVideo =
            item?.files?.[0]?.full_url && item?.files?.[0]?.type === "video";
          const imgUrl = isVideo
            ? item?.files?.[0]?.preview
            : item?.files?.[0]?.full_url;
          return imgUrl ? (
            <>
              <div className="w-100 text-center " style={{ minWidth: "150px" }}>
                <div
                  style={{ width: "90px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    setTypeScreen("feed");
                    if (item?.files?.length > 1) {
                      setLinkImage({
                        urls: item?.files,
                        keyword: {
                          title: item?.title,
                          keyword: item?.description,
                        },
                      });
                    } else {
                      setLinkImage({ url: imgUrl });
                    }
                    document.body.className = "modal-open_img";
                  }}
                >
                  <img
                    src={imgUrl}
                    className="flex-shrink-0 rounded w-100"
                    alt="thumbnail"
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          );
        },
      },
      // {
      //   Header: t("Title"),
      //   accessor: "title",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: 200,
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     const isVideo =
      //       item?.files?.[0]?.url && item?.files?.[0]?.type === "video";
      //     return (
      //       <>
      //         <div
      //           className="cursor-pointer"
      //           style={{ minWidth: "200px" }}
      //           onClick={() => {
      //             setLinkImage({
      //               url: item?.files?.[0]?.url,
      //               isVideo: isVideo,
      //               keyword: { title: item?.title, keyword: item?.description },
      //             });
      //             document.body.className = "modal-open_img";
      //           }}
      //         >
      //           {truncate(cell?.value, 70)}
      //         </div>
      //       </>
      //     );
      //   },
      // },
      {
        Header: t("Content"),
        accessor: "contents",
        filterable: true,
        sortable: false,
        thWidth: 250,
        thClass: "align-middle",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const isVideo =
            item?.files?.[0]?.url && item?.files?.[0]?.type === "video";
          return (
            <>
              <CollapseContent
                style={{ minWidth: "200px" }}
                dataOriginal={cell?.value}
                isRank={false}
                isInlineBlock={true}
                isShowModal={true}
                titleModal={t("Content")}
              />
            </>
          );
        },
      },
      {
        Header: t("Store Name"),
        accessor: "barName",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: "180",
        Cell: (cell: any) => {
          const row = cell?.row?.original;
          return (
            row?.bar?.id ? (
              <>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setItemToBarDetail(row?.bar);
                    setTypeScreen("FeedToBar");
                  }}
                  style={{
                    width: "180px",
                    color: "#009ef7",
                  }}
                >
                  {row?.bar?.title}
                </div>
              </>
            ) : "-"
          );
        },
      },
      {
        Header: t("User"),
        accessor: "bartender",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "align-middle whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;

          return item?.user_profile?.nickname && (
            <>
              <div className="">
                {item?.user_profile?.nickname}
              </div>
            </>
          );
        },
      },

      {
        Header: t("User Type"),
        accessor: "user_type",
        filterable: true,
        sortable: false,
        thWidth: 100,
        thClass: "align-middle whitespace-nowrap text-center",
        Cell: (cell: any) => {
          const userType = cell?.row?.original?.user_profile?.type;

          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_WINK_TYPE_USER[userType] || "secondary"
                  }`}
              >
                {t(
                  WINK_TYPE_USER_OPTION?.find(
                    (item: any) => (item?.value) === (userType)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Like"),
        accessor: "like_count",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "align-middle text-end",
        Cell: (cell: any) => {
          return (
            <>
              <div className="text-end pe-3" style={{ minWidth: "100px" }}>
                {formatNumberWithCommas(cell?.value)}
              </div>
            </>
          );
        },
      },
      {
        Header: "",
        accessor: "__",
        filterable: false,
        sortable: false,
        thWidth: 30,
        thClass: "align-middle text-end",
        Cell: (cell: any) => {
          return (
            <>

            </>
          );
        },
      },
      {
        Header: t('Views'),
        accessor: "pv",
        thClass: 'align-middle text-end',
        filterable: false,
        sortable: false,
        thWidth: 240,
        thComponent: () => (
          <table>
            <thead>
              <tr>
                <th className="text-center pb-1 none-sticky" colSpan={2}>
                  {t('Views')}
                </th>
              </tr>
              <tr>
                <tr>
                  <th className="text-center px-0 py-1 cursor-pointer none-sticky" style={{ width: '120px' }}
                  >
                    {t('PV')}
                  </th>
                  <th className="text-center px-0 py-1 cursor-pointer none-sticky" style={{ width: '120px' }}
                  >
                    {t('UV')}
                  </th>
                </tr>
              </tr>
            </thead>
          </table>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div className="d-flex text-center">
              <div style={{ width: '120px' }}>{formatNumberWithCommas(item?.pv)}</div>
              <div style={{ width: '120px', borderLeft: "1px solid #eaeaea" }}>{formatNumberWithCommas(item?.uv)}</div>
            </div>
          );
        },
      },
      {
        Header: t("Comment"),
        accessor: "comment_count",
        filterable: false,
        sortable: false,
        thWidth: 100,
        thClass: "align-middle text-end",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <>
              <div
                className="text-end text-primary cursor-pointer"
                style={{ minWidth: "70px" }}
                onClick={() => {
                  setTypeScreen("comment");
                  setItemToComment(item);
                }}
              >
                {formatNumberWithCommas(cell?.value)}
              </div>
            </>
          );
        },
      },

      {
        Header: t("Share"),
        accessor: "share_count",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "align-middle text-end",
        Cell: (cell: any) => {
          return (
            <>
              <div className="text-end" style={{ minWidth: "90px" }}>
                {formatNumberWithCommas(cell?.value)}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: false,
        sortable: false,
        thWidth: 150,
        thClass: "align-middle text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end pe-3" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "align-middle text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "align-middle text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ width: "120px", justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    [i18n?.language, posts?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  // Begin::Delete

  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await PostApi?.deletePost(id);
      if (response?.data) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // End::Delete

  const handleCloseModalBarDetail = () => {
    setItemToBarDetail(null);
  };

  const onCloseCommentClick = () => {
    setItemToComment(null);
  };

  const onCloseEditWinkClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  useEffect(() => {
    document.title = `${t("Wink")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Wink")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={posts?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    <div className="col-sm-auto text-end">
                      <button
                        type="button"
                        className="btn btn-success d-md-block"
                        onClick={() => {
                          setIsOpen(true);
                          setItemToEdit(null);
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Button Create Wink")}
                      </button>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-md-2 mt-0">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Content")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Content")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Store")} isShow={true}>
                          <DropdownAsyncBars
                            name="bar"
                            onChangeSelect={(event: any) => setBarSearch(event)}
                            isMulti={false}
                            placeholder={`${t("Select Store")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={barSearch}
                            partnerStatus="partnered"
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("User Type")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={WINK_TYPE_USER_OPTION || []}
                            placeholder={`${t("User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={userTypeSearch}
                            onChangeSelect={(event: any) => {
                              setUserTypeSearch(event?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_WINK_TYPE_USER}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Users")} isShow={true}>
                          <DropdownAsyncUserWink
                            name="bartender"
                            onChangeSelect={(event: any) =>
                              setBartenderSearch(event)
                            }
                            isMulti={false}
                            placeholder={`${t("Select User")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={bartenderSearch}
                            isClearable={false}
                            key={`user-${userTypeSearch}`}
                            paramsTypeUsers={userTypeSearch}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_FEED_OPTION_LANG || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(event: any) => {
                              setStatusSearch(event?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_POST}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!start_date || !!end_date}
                        >
                          <DatePickerCustom
                            startDate={start_date || null}
                            endDate={end_date || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={6}
                        xxl={6}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                            disabled={isPostLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-wink-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={posts?.list?.length ? posts?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={posts?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(posts?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isPostLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Wink")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        {isOpen && (
          <CreateEditWink
            onCloseEditWinkClick={onCloseEditWinkClick}
            item={itemToEdit}
            loadTableData={loadTableData}
            setLinkImage={setLinkImage}
            onCloseImageClick={onCloseImageClick}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
          typeScreen={typeScreen}
        />

        {itemToBarDetail && (
          <Modal
            isOpen={!!itemToBarDetail}
            centered={true}
            size="xl"
            className="modal-fullscreen"
            scrollable={false}
          >
            <ModalHeader toggle={handleCloseModalBarDetail}>
              {itemToBarDetail?.title || ""}
            </ModalHeader>
            <ModalBody>
              <BarListDetail
                barID={itemToBarDetail?.id}
                setLinkImage={setLinkImage}
              // isShowDetail={true}
              />
            </ModalBody>
          </Modal>
        )}

        {itemToComment && (
          <ModalComment
            isOpen={true}
            item={itemToComment}
            winkId={itemToComment?.id}
            setLinkImage={setLinkImage}
            onClose={onCloseCommentClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default MediaList;
